<template>
  <QTable
    class="full-width"
    :columns="briefSetUsersColumns"
    :hide-bottom="filteredBriefSetUsers.length <= 100"
    :loading="loading"
    :pagination="pagination"
    row-key="name"
    :rows="filteredBriefSetUsers"
    :rows-per-page-options="rowPerPageOptions"
    style="height: 450px"
    title="Users"
  >
    <template #top="props">
      <div class="row q-table__title">Users</div>

      <QSpace />

      <div class="row">
        <QToggle
          v-model="allUsers"
          :label="`${allUsers ? 'Disable' : 'Enable'} All Users`"
        />
        <QIcon
          v-if="showFullscreenOption"
          class="q-ml-md cursor-pointer self-center"
          :name="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'"
          size="20px"
          @click="props.toggleFullscreen"
        >
          <StreemTooltip>
            {{ props.inFullscreen ? "Exit" : "Enter" }}
            Fullscreen</StreemTooltip
          >
        </QIcon>
      </div>
    </template>

    <template #top-row>
      <QTr class="filter-row">
        <QTd>
          <QInput
            v-model="filter.id"
            borderless
            clearable
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd>
          <QInput
            v-model="filter.name"
            borderless
            clearable
            debounce="300"
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd>
          <QInput
            v-model="filter.email"
            borderless
            clearable
            debounce="300"
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd>
          <QInput
            v-model="filter.teamName"
            borderless
            clearable
            debounce="300"
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd />
        <QTd />
      </QTr>
    </template>

    <template #body="props">
      <QTr :props="props">
        <QTd
          key="id"
          class="wrap-table-content"
          :props="props"
        >
          {{ props.row.id }}
        </QTd>
        <QTd
          key="name"
          class="wrap-table-content"
          :props="props"
        >
          {{ props.row.name }}
        </QTd>
        <QTd
          key="email"
          class="wrap-table-content"
          :props="props"
        >
          {{ props.row.email }}
        </QTd>
        <QTd
          key="team"
          class="wrap-table-content"
          :props="props"
        >
          {{ props.row.teamName }}
        </QTd>
        <QTd
          key="enabled"
          class="wrap-table-content"
          :props="props"
        >
          <QToggle
            :model-value="props.row.enabled"
            @update:model-value="toggleUser(props.row)"
          />
        </QTd>
      </QTr>
    </template>
  </QTable>
</template>

<script>
import { tableFilter } from "shared/helpers/object";

export default {
  name: "BriefSetUsersForm",
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    users: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
    },
    showFullscreenOption: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      briefSetUsers: [],
      briefSetUsersColumns: [
        {
          name: "id",
          align: "left",
          label: "ID",
          field: "id",
          sortable: true,
          style: "width: 10%",
        },
        {
          name: "name",
          align: "left",
          label: "Name",
          field: "name",
          sortable: true,
          style: "width: 30%",
        },
        {
          name: "email",
          align: "left",
          label: "Email",
          field: "email",
          sortable: true,
          style: "width: 30%",
        },
        {
          name: "team",
          align: "left",
          label: "Team",
          field: (row) => row.organisation_team.name,
          sortable: true,
          style: "width: 10%",
        },
        {
          name: "enabled",
          align: "center",
          label: "Enabled",
          field: "enabled",
          sortable: true,
          style: "width: 10%",
        },
      ],
      pagination: {
        rowsPerPage: 100,
      },
      rowPerPageOptions: [25, 50, 100, 250, 500],
      filter: {
        name: "",
        id: null,
        email: "",
        teamName: "",
      },
    };
  },
  computed: {
    filteredBriefSetUsers() {
      return this.briefSetUsers.filter((user) =>
        tableFilter(user, this.filter)
      );
    },
    allUsers: {
      get() {
        return this.filteredBriefSetUsers.every((user) => user.enabled);
      },
      set(value) {
        this.toggleUsers(value);
      },
    },
  },
  mounted() {
    this.setBriefSetUsers();
  },
  methods: {
    setBriefSetUsers() {
      this.briefSetUsers = this.users.map((user) => {
        const enabledUser = this.modelValue.find(
          ({ userId }) => Number(userId) === Number(user.id)
        );

        return {
          ...user,
          enabled: Boolean(enabledUser),
        };
      });
    },
    toggleUsers(value) {
      if (value) {
        this.filteredBriefSetUsers.forEach((user) => {
          Object.assign(user, { enabled: true });
        });
      } else {
        this.filteredBriefSetUsers.forEach((user) => {
          Object.assign(user, { enabled: false });
        });
      }

      this.updateUsers();
    },
    toggleUser(user) {
      Object.assign(user, {
        enabled: !user.enabled,
      });

      this.updateUsers();
    },
    updateUsers() {
      this.$emit("update:modelValue", this.briefSetUsers);
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  .wrap-table-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    word-wrap: break-word;
    overflow-wrap: break-word;
    font-size: 14px;
  }
}

.fullscreen {
  height: 100% !important;
}
</style>
